<template>
  <div class="card">
    <div class="card-header bg-info" />

    <div class="card-body">
      <h5 class="card-title" v-html="$t('RunningOrderNote.title')" />
      <p class="card-text" v-html="$t('RunningOrderNote.content', { onHoldUrl })" />
    </div>
  </div>
</template>

<script>
import messages from 'locales/RunningOrderNote';

export default {
  name: 'RunningOrderNote',
  i18n: { messages },
  props: {
    onHoldUrl: String,
  },
};
</script>

<style scoped>

</style>
